// extracted by mini-css-extract-plugin
export default {"nombres":"weatherMain_nombres__SPBQF","imgText":"weatherMain_imgText__iMtYw","text":"weatherMain_text__Dn-H6","iframe":"weatherMain_iframe__1ZU63"};